import React, { useContext, useState } from "react";
import { store } from "store";
import InternalLink from "components/InternalLink";
import Loading from "components/Loading";
import { resetPasswordUrlRedirect } from "core/Utils/resetPasswordUrlRedirect";
import Modal from "components/Modal";

const analytics = {
  "data-gtm-event-category": "minha-claro:meu-perfil",
  "data-gtm-event-action": "clique:menu-opcoes",
};

export default function LeftMenu() {
  const [isLoading, setIsLoading] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const globalState = useContext(store);
  const { user } = globalState.state;

  const links = [
    {
      label: "Alterar e-mail",
      link: "/meuperfil/alterar-email",
      eventLabel: "alterar-email",
      id: "mdn-MainContent",
      tabIndex: 13,
    },
    {
      label: "Alterar senha",
      link: "#",
      eventLabel: "alterar-senha",
      onClick: handleResetPassword,
      tabIndex: 14,
    },
    {
      label: "Acesso pelo celular",
      link: "/meuperfil/acesso-pelo-celular",
      eventLabel: "acesso-pelo-celular",
      tabIndex: 16,
    },
  ];

  async function handleResetPassword() {
    setIsLoading(true);
    const result = await resetPasswordUrlRedirect(user);
    setIsLoading(false);

    if (result?.errorCode) {
      setModalContent(result);
    }
  }

  function onRequestClose() {
    setModalContent(null);
  }

  return (
    <>
      <Loading isLoading={isLoading} />
      <Modal onClose={onRequestClose} content={modalContent} />
      <div aria-label="Opções do perfil" className="cred-LeftNavigation" role="navigation">
        {links.map(({ eventLabel, label, ...linkProps }) => (
          <div className="cred-LeftNavigationGroup" key={eventLabel}>
            <div className="cred-LeftNavigationLink">
              <InternalLink
                {...analytics}
                {...linkProps}
                className="cred-LeftNavigationAction"
                data-gtm-event-label={eventLabel}
              >
                {label}
              </InternalLink>
              <i
                aria-hidden="true"
                className="mdn-Icon-direita mdn-Icon--sm cred-LeftNavigationArrow"
              ></i>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
